import {Target, TargetType} from "../TargetSelector";
import {GetCallbackDataQuery} from "./queries.generated";

export const gatewayCallbackDataToTargets = (data: GetCallbackDataQuery): Target[] => {
    const extensionTargets: Target[] = data.users.items.map((ext) => ({
        numberId: ext.number.id,
        displayName: ext.displayName,
        shortNumber: ext.number.shortNumber,
        type: TargetType.EXTENSION,
    }));

    return extensionTargets.concat(
        data.faxes.items.map(
            (fax): Target => ({
                numberId: fax.number.id,
                displayName: null,
                shortNumber: fax.number.shortNumber,
                type: TargetType.FAX,
            }),
        ),
        data.groups.items.map((group) => ({
            numberId: group.number.id,
            displayName: group.name,
            shortNumber: group.number.shortNumber,
            type: TargetType.GROUP,
        })),
        data.ivrs.items.map((ivr) => ({
            numberId: ivr.number.id,
            displayName: ivr.name,
            shortNumber: ivr.number.shortNumber,
            type: TargetType.IVR,
        })),
    );
};
